import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class ReminderService {

  private readonly remindersUrl = environment.main_url + "/agilelegal/reminders";
  private readonly usersUrl = environment.main_url + environment.lpcUsersList;

  constructor(private http: HttpClient) { }

  getUsers(payload: any): Observable<any> {
    return this.http.post<any>(this.usersUrl, payload);
  }

  getReminders(taskId: number | null, projectId: number | null): Observable<any[]> {
    if (taskId) {
      return this.http.get<any[]>(`${this.remindersUrl}/task/${taskId}`);
    } else if (projectId) {
      return this.http.get<any[]>(`${this.remindersUrl}/project/${projectId}`);
    } else {
      // fallback: return empty array observable if neither is provided
      return new Observable<any[]>(observer => {
        observer.next([]);
        observer.complete();
      });
    }
  }

  createReminder(payload: any): Observable<any> {
    return this.http.post(this.remindersUrl, payload);
  }
  
  updateReminder(reminderId: number, payload: any): Observable<any> {
    return this.http.put(`${this.remindersUrl}/${reminderId}`, payload);
  }

  deleteReminder(reminderId: number): Observable<any> {
    return this.http.delete(`${this.remindersUrl}/${reminderId}`);
  }

}
